module.exports = __webpack_public_path__ + "img/Unidad6-1.a5e6650c.png";